<script>
  import { mapState, mapMutations } from 'vuex';
  import IconClose from '@/assets/icon-close.svg';
  import IconPencil from '@/assets/icon-pencil.svg';

  export default {
    components: {
      IconClose,
      IconPencil,
    },

    computed: {
      ...mapState('bank', [
        'list',
      ]),
    },

    methods: {
      ...mapMutations('bank', [
        'REMOVE',
      ]),

      edit (id) {
        this.$router.push(`/conta/contas-bancarias/${id}/editar`);
      },
    },
  };
</script>

<template>
  <main class="account-bank">
    <header class="account-bank__header">
      <h1 class="sidebar__title">Contas bancárias</h1>

      <RouterLink
        append
        to="adicionar"
        class="account-bank__action"
        >
        Adicionar conta
      </RouterLink>
    </header>

    <ul class="account-bank__list">
      <li
        :key="id"
        class="account-bank__item"
        v-for="({ id, name, account, agency }, index) in list"
        >
        <img class="account-bank__item-icon" src="@/assets/itau.png">

        <div class="account-bank__item-content">
          <h4 class="account-bank__item-title">Banco {{ name.toUpperCase() }}</h4>
          <p class="account-bank__item-infos">
            <span class="account-bank__item-info">
              Agência: {{ agency }}
            </span>
            <span class="account-bank__item-info">
              Conta corrente: {{ account }}
            </span>
          </p>
        </div>

        <button
          @click.prevent="edit(id)"
          class="account-bank__item-action"
          >
          <IconPencil />
        </button>

        <button
          @click.prevent="REMOVE(index)"
          class="account-bank__item-action"
          >
          <IconClose />
        </button>
      </li>
    </ul>

    <transition name="fade">
      <RouterView />
    </transition>
  </main>
</template>

<style lang="scss">
  .account-bank {
    &__header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    &__action {
      color: #FFF;
      display: flex;
      line-height: 1;
      min-width: 219px;
      padding: 14px 16px;
      border-radius: 4px;
      align-items: center;
      letter-spacing: .32px;
      align-self: flex-start;
      justify-content: center;
      background-color: #3e388b;

      &:hover {
        background-color: #322c76;
      }
    }

    &__item {
      padding: 24px;
      display: flex;
      align-items: center;

      &-icon {
        margin-right: 24px;
      }

      &-title {
        font-size: 20px;
        margin-bottom: 8px;
        letter-spacing: .4px;
        color: rgba(#FFF, .8);
      }

      &-content {
        margin-right: auto;
      }

      &-info {
        font-size: 14px;
        line-height: 1.14;
        margin-right: 24px;
        color: rgba(#b2b8c5, .7);
      }

      &-action {
        display: flex;
        width: 40px;
        height: 32px;
        align-items: center;
        justify-content: center;

        svg {
          width: 16px;
          height: 16px;
        }
      }

      &:not(:last-child) {
        border-bottom: 1px solid rgba(#939cac, .15);
      }

      &:nth-child(even) {
        background-color: #14162f;
      }
    }
  }
</style>
